export default __webpack_public_path__ + "static/media/food-logo2.71dbfa18.png";